export const VIEW_KEYS = {
  INITIAL: 0,
  SIGNIN: 1,
  SIGNUP: 2,
};
